import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import {
  RpaOperationTemplatesRequestParams,
  RpaTwoFactorAuthSetting,
  ConnectingServiceList,
  TriggerConnectingServiceList,
} from "../types/types";

// PATCH: http://localhost/:client_code/workflow_templates/:workflow_template_id/rpa_operation_templates/:id
export const apiRpaOperationTemplatesSubmit = async (
  clientCode: string,
  workflowTemplateId: number,
  operationId: number,
  requestParams: RpaOperationTemplatesRequestParams,
) => {
  const response = await axios
    .patch(
      `/${clientCode}/workflow_templates/${workflowTemplateId}/rpa_operation_templates/${operationId}`,
      requestParams,
    )
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const apiRpaOperationTemplatesTest = async (
  clientCode: string,
  workflowTemplateId: number,
  operationId: number,
  requestParams: RpaOperationTemplatesRequestParams,
) => {
  const response = await axios
    .post(
      `/${clientCode}/workflow_templates/${workflowTemplateId}/rpa_operation_templates/${operationId}/request_test`,
      requestParams,
    )
    .catch((error) => {
      return error.response;
    });

  return response;
};

export const apiRpaOperationTemplateTerminateTest = async (
  clientCode: string,
  workflowTemplateId: number,
  operationId: number,
) => {
  const response = await axios
    .get(
      `/${clientCode}/workflow_templates/${workflowTemplateId}/rpa_operation_templates/${operationId}/terminate_test`,
    )
    .catch((error) => {
      return error.response;
    });

  return response;
};

export const apiRpaOperationTemplateOutputs = async (
  clientCode: string,
  workflowTemplateId: number,
  operationId: number,
) => {
  const response = await axios
    .get(`/${clientCode}/workflow_templates/${workflowTemplateId}/rpa_operation_templates/${operationId}/fetch_outputs`)
    .catch((error) => {
      error.response;
      return error.response;
    });
  return response;
};

export const apiRpaOperationTemplateTestResult = async (
  clientCode: string,
  workflowTemplateId: number,
  operationId: number,
  priority: number,
) => {
  const response = await axios
    .get(
      `/${clientCode}/workflow_templates/${workflowTemplateId}/rpa_operation_templates/${operationId}/fetch_test_result`,
      { params: { priority: priority } },
    )
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const apiAppTriggerAutoOffExtend = async (
  clientCode: string,
  workflowTemplateId: number,
  appTriggerId: number,
) => {
  const response = await axios
    .patch(
      `/${clientCode}/workflow_templates/${workflowTemplateId}/app_triggers/${appTriggerId}/extend_draft_auto_off_date`,
    )
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const updateHubspotContact = async (clientCode: string, hubspotContact: object) => {
  const response = await axios.patch(`/${clientCode}/members/hubspot_contact`, hubspotContact).catch((error) => {
    return error.response;
  });
  return response;
};

export const createRpaAccount = async (
  clientCode: string,
  client_id: number,
  member_id: number,
  service_name: string,
  account_id: string,
  password: string,
) => {
  const response = await axios
    .post(`/${clientCode}/rpa_accounts`, {
      rpa_account: {
        client_id: client_id,
        owner_id: member_id,
        service_name: service_name,
        account_id: account_id,
        password: password,
      },
    })
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const getRpaTwoFactorAuthSettingCode = async (
  clientCode: string,
  rpa_two_factor_auth_setting: RpaTwoFactorAuthSetting,
) => {
  const response = await axios
    .get(`/${clientCode}/rpa_two_factor_auth_settings/${rpa_two_factor_auth_setting.id}/fetch_code`)
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const apiOutputTransformOperationTemplates = async (requestUrl: string) => {
  const response = await axios.post(requestUrl).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiCopyWorkflowTemplate = async (requestUrl: string) => {
  const response = await axios.get(requestUrl).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiDeleteWorkflowTemplate = async (requestUrl: string) => {
  const response = await axios.delete(requestUrl).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiUpdateWorkflowCompletionNotification = async (requestUrl: string, isNotify: boolean) => {
  const response = await axios
    .patch(requestUrl, {
      complete_notification: isNotify ? "enabled" : "disabled",
    })
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const apiUpdateWorkflowPublish = async (requestUrl: string, isPublish: boolean) => {
  const response = await axios
    .patch(requestUrl, {
      workflow_template: {
        published: isPublish ? 1 : 0,
      },
    })
    .catch((error) => {
      return error.response;
    });
  return response;
};

export const apiUpdateAjaxRequest = async (requestUrl: string, requestParams: object) => {
  const response = await axios.patch(requestUrl, requestParams).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiFetchWorkflowTemplateIcon = async (clientCode: string, workflowTemplateId: number) => {
  const response = await axios.get(`/${clientCode}/icons/workflow_templates/${workflowTemplateId}`).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiFetchOperationList = async () => {
  const currentUrl = window.location.href;
  const requestUrl = currentUrl.includes("edit")
    ? currentUrl.replace("edit", "operation_list")
    : `${currentUrl}/operation_list`;
  const response = await axios.get(requestUrl).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiDuplicateOperation = async ({
  id,
  params,
}: {
  id: number;
  params: {
    previous_workflow_template_action_id: number;
    next_workflow_template_action_id?: number;
    switch_command_logic_template_id?: number;
  };
}) => {
  const currentUrl = window.location.href;
  const endpoint = `${currentUrl.replace("edit", `workflow_template_actions/${id}/copy`)}`;
  const response = await axios.get(endpoint, { params }).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiFetchServiceActions = async (connectingServices: ConnectingServiceList) => {
  const currentUrl = window.location.href;
  const requestUrl = currentUrl.includes("edit")
    ? currentUrl.replace("edit", "fetch_operation_service_actions")
    : `${currentUrl}/fetch_operation_service_actions`;
  const response = await axios.post(requestUrl, { connectingServices: connectingServices }).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiFetchTriggerServiceActions = async (connectingServices: TriggerConnectingServiceList) => {
  const currentUrl = window.location.href;
  const requestUrl = currentUrl.includes("edit")
    ? currentUrl.replace("edit", "fetch_trigger_service_actions")
    : `${currentUrl}/fetch_trigger_service_actions`;
  const response = await axios.post(requestUrl, { connectingServices: connectingServices }).catch((error) => {
    return error.response;
  });
  return response;
};

export const apiFetchClientTimezone = async () => {
  const clientCode = window.location.pathname.split("/")[1];
  const endpoint = `/clients/${clientCode}/timezone`;
  const response = await axios.get(endpoint).catch((error) => {
    return error.response;
  });
  return response;
};
